import { Stack } from '@mui/material';
import { FC } from 'react';

import { Button } from '@/shared/design-system';

interface StepFooterProps {
  onBack?: () => void;
  backLabel?: string;
  onNext?: () => void;
  nextLabel?: string;
  nextDisabled?: boolean;
  nextLoading?: boolean;
  onSkip?: () => void;
  skipLabel?: string;
}

export const StepFooter: FC<StepFooterProps> = ({
  onBack,
  backLabel = 'Back',
  onNext,
  nextLabel = 'Continue',
  nextDisabled = false,
  nextLoading = false,
  onSkip,
  skipLabel = 'Skip',
}) => {
  const hasBack = !!onBack;
  const hasNext = !!onNext;
  const hasSkip = !!onSkip;

  if (!hasBack && !hasNext && !hasSkip) return null;

  return (
    <Stack gap="8px" justifyContent="space-between">
      {hasBack && (
        <Button color="tertiary" variant="outline" size="lg" onClick={onBack}>
          {backLabel}
        </Button>
      )}

      <Stack gap="8px" marginLeft={hasBack ? 'auto' : undefined}>
        {hasSkip && (
          <Button color="tertiary" variant="outline" size="lg" onClick={onSkip}>
            {skipLabel}
          </Button>
        )}
        {hasNext && (
          <Button
            color="primary"
            variant="solid"
            size="lg"
            onClick={onNext}
            disabled={nextDisabled || nextLoading}
          >
            {nextLabel}
          </Button>
        )}
      </Stack>
    </Stack>
  );
};
